export default __webpack_public_path__ + "static/media/img-banner-dark-2.51603496.png";